import React, { Component } from 'react'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import LoanDocumentSubNavUI from './LoanDocumentSubNavUI.js'

class LoanDocumentSubNavSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      viewDocumentErrorList: null,
      viewDocumentSubmitted: false,
      sendForEsignMode: false
    }
  }

  render() {
    return (
      <LoanDocumentSubNavUI
        context={this.props.context}
        loan={this.props.loan}
        documentCode={this.props.documentCode}
        basePath={this.props.basePath}
        page={this.props.page}
        onRefreshClick={this.props.onRefreshClick}
        viewDocumentSubmitted={this.state.viewDocumentSubmitted}
        viewDocumentErrorList={this.state.viewDocumentErrorList}
        onViewDocumentClick={this.onViewDocumentClick}
        onSendForEsignClick={() => { this.setState({ sendForEsignMode: true }) }}
        onSendForEsignCancel={() => { this.setState({ sendForEsignMode: false }) }}
        sendForEsignMode={this.state.sendForEsignMode}
        successMsg={this.state.successMsg}
      />
    )
  }

  onViewDocumentClick = () => {
    if (this.state.viewDocumentSubmitted) return

    this.setState({ viewDocumentErrorList: null, viewDocumentSubmitted: true })
    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/documents/${this.props.documentCode}/fileDownloadSignedUrl`,
      this.onViewDocumentCallback, {}
    )
  }

  onViewDocumentCallback = (response) => {
    this.setState({
      viewDocumentErrorList: response.errorList,
      viewDocumentSubmitted: false,
      successMsg: response.success,
    })
    if (response.errorList && response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      this.props.onRefreshClick('noBusy')
    }
  }

}

export default LoanDocumentSubNavSF
